<template>

    <div class="container-fluid"> <!-- @if($nbResourcesFound === 0) -->
        <a href="/ressources/" class="dark-gray-link back-resources ms-lg-3"><i class="fa-light fa-arrow-left" aria-hidden="true"></i>
            Ressources</a>
    </div>

    <div class="container">
        <h1 class="page-title">
            Résultats de recherche
        </h1>
        <hr>
        <div class="no-result-hero row align-items-center justify-content-center">
            <div class="col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0">
                <img src="/_/images/anim-dossiers.gif?v=2" class="img-fluid" alt="">
            </div>
            <div class="col-12 col-lg-8">
                <h2 class="mb-4">Aucun résultat</h2>
                <p class="mb-3">Votre recherche n’a donné aucun résultat.</p>
                <p>Vérifiez l’orthographe des mots ou tapez un autre terme.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NoResult"
}
</script>

<style scoped>

</style>
